import { getData } from "../dataCaching/cmpStorageManager";
import { getCurrentJwt } from "../jwt/decryptToken";
import { API } from "aws-amplify";
import CryptoJS from 'crypto-js'

export async function fetchHtmlReportingConfig() {
  let data = await getData('cmp', 'cmp', 'clientConfig')
  if (data) {
    if (data.hasOwnProperty('htmlReporting')) {
      return data.htmlReporting
    }
  }
  return null
}

export async function fetchHtmlReportData(reportName) {
  const clientName = JSON.parse(
    CryptoJS.AES.decrypt(
      localStorage.getItem("conceptName"),
      process.env.REACT_APP_PASS
    ).toString(CryptoJS.enc.Utf8)
  )
  const options = {
    headers: {
      Authorization: getCurrentJwt()
    },
    body: {
    },
  };

  let sleepTime = 1000
  let res = null
  while (true) {
    try {
      res = await API.get(process.env.REACT_APP_AMPLIFY_API, `/html-reporting/s3-url?clientName=${clientName}&reportName=${reportName}`, options).then(data => data)
      return res.url
    }
    catch (e) {
      console.log(e)
      sleepTime *= 2
      await new Promise(resolve => setTimeout(resolve, sleepTime));
    }
  }
}


// WEBPACK FOOTER //
// ./src/util/htmlReporting/htmlReporting.js